import { Injectable } from '@angular/core';

// Serviço utilizado para calcular parâmetros de paginação para trabalhar com a paginacao no back-end
@Injectable({
    providedIn: 'root'
  })
export class PaginacaoBackUtilsService {

    tamanhoPagina = 400;

    constructor() { }

    public obterNumeroPaginaBack(paginaFront: number, tamanhoPaginaFront: number) {
        if (paginaFront < 1 || tamanhoPaginaFront < 1) {
            alert('Falha nao esperada no componente de paginacao. Favor informar ao DESIS.');
            return;
        }
        return Math.ceil(((paginaFront * tamanhoPaginaFront ) / this.tamanhoPagina));
    }

    public obterTamanhoPaginaBack(): number {
        return this.tamanhoPagina;
    }
}
